import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Card } from 'reactstrap';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
}));

export function CommonLoader({ size = 30, color }) {
  return <CircularProgress color={color || 'secondary'} size={size} style={{ marginRight: 10 }} />;
}

export const LoadingCard = ({ size = 30, color }) => (
  <Card style={{ marginTop: 10, marginBottom: 10 }}>
    <div style={{ padding: 20, textAlign: 'center' }}>
      <CommonLoader size={size} color={color} />
    </div>
  </Card>
);

export default function Loader({ size = 24, style, color }) {
  const classes = useStyles();

  return (
    <div className={classes.root} style={{ ...style }}>
      <CircularProgress color={color || 'secondary'} size={size} style={{ marginRight: 10 }} />
    </div>
  );
}
